import Wrapper from "./facebook.styles";
import { BsFacebook } from "react-icons/bs";
import { Link } from "react-router-dom";
import { useAppContext } from "../../layout/layout";

const Facebook = () => {
  const { isDarkTheme } = useAppContext();
  return (
    <Wrapper>
      <Link to="/">
        <BsFacebook
          className={`icon ${isDarkTheme ? "dfacebook" : "lfacebook"}`}
        />
      </Link>
    </Wrapper>
  );
};
export default Facebook;
